module.exports = __webpack_public_path__ + "static/media/ActivityCard-BuzzQuiz.94e45647.svg";